import { Box, Typography } from '@mui/material';
import { useUpload } from '../hooks/useUpload';
import { en } from '../translations/en';
import { getCrossOrigin } from '../utils/imageUtils';
import { useWizardAccordionVariant } from './edit-object/WizardAccordionStyleContext';

export const ImageThumbnail = () => {
  const { getCoverImage, aliCatalogNumber, catalogTitle } = useUpload();
  const variant = useWizardAccordionVariant();
  const coverImage = getCoverImage();

  // The Artwork Details page intentionally drops per-tab thumbnail headers —
  // the design uses one big primary image area at the page top (now removed)
  // rather than repeating the thumbnail inside each step.
  if (variant === 'describe') return null;

  if (!coverImage) return null;

  // Get the image URL - use thumbnailUrl if available, otherwise create blob URL from file
  const imageUrl = coverImage.thumbnailUrl || (coverImage.file ? window.URL.createObjectURL(coverImage.file) : null);

  if (!imageUrl) return null;

  return (
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 2,
      mb: 2,
      p: 2,
      bgcolor: 'background.paper',
      borderRadius: 1,
      border: '1px solid',
      borderColor: 'divider'
    }}>
      <Box
        component="img"
        crossOrigin={getCrossOrigin(imageUrl)}
        src={imageUrl}
        alt={en.imageThumbnail.altText}
        sx={{
          width: 60,
          height: 60,
          objectFit: 'contain',
          borderRadius: 1
        }}
      />
      <Box>
        <Typography variant="body2" color="text.secondary">
          {catalogTitle
            ? en.imageThumbnail.addingInfoWithTitle.replace('{title}', catalogTitle)
            : en.imageThumbnail.addingInfo}
        </Typography>
        {aliCatalogNumber && (
          <Typography variant="caption" color="text.secondary" sx={{ fontFamily: 'monospace' }}>
            {en.imageThumbnail.catalogNumberPrefix} {aliCatalogNumber}
          </Typography>
        )}
      </Box>
    </Box>
  );
};
